import { ButtonSkeleton } from "@/components/ui/button";
import { CardSkeleton } from "@/components/ui/card";
import { TextSkeleton } from "@/features/projects/components/text-skeleton";

/*
 * ContextPackDropzoneSkeleton component
 */
export const ContextPackDropzoneSkeleton = () => {
  /* Render */
  return (
    <>
      <div className="flex justify-between items-center w-full">
        <TextSkeleton variant="h1" />
        <div className="flex gap-2">
          <ButtonSkeleton />
          <ButtonSkeleton />
        </div>
      </div>

      {/* Editor */}
      <div className="grow flex flex-row bg-base-300 rounded-lg overflow-hidden max-h-full h-screen relative skeleton"></div>

      {/* Bottom navigation */}
      <div className="flex justify-center items-center w-full gap-4">
        <CardSkeleton size="small" className="min-w-[162px]" loadBody={false} loadTitle={false}></CardSkeleton>
        <CardSkeleton size="small" className="min-w-[162px]" loadBody={false} loadTitle={false}></CardSkeleton>
        <CardSkeleton size="small" className="min-w-[162px]" loadBody={false} loadTitle={false}></CardSkeleton>
      </div>
    </>
  );
};
